<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="min-width: 40rem; width: 40rem;">
                <div class="modal-header">
                    <slot name="header">
                        <div>
                            <h3 class="form-header">Fill Administration</h3>
                            <p style="text-align: left; font-size: 0.9em; margin: 5px 0 0 0; max-width: 34rem;">
                                Administrations are not drug register lines. For facilities wanting to track these
                                records, this data can be filled for relevant drug safe retrieval records.
                            </p>
                        </div>
                        <button @click="closeModal()" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0"></i>
                        </button>
                    </slot>
                </div>

                <div class="modal-body">
                    <slot name="body">
                        <div v-if="!submitSuccess" class="fill-administration-fields">
                            <div v-for="field in fields" :key="field.label" class="fill-administration-field">
                                <p class="field-title">{{ field.label }}</p>
                                <p class="field-value">{{ field.value || 'N/A' }}</p>
                            </div>
                        </div>
                        <p v-if="submitSuccess" style="color: #00AD50; font-weight: 500; text-align: center; margin: 2em 0;">
                            Administration recorded.
                        </p>
                        <p v-if="errorMessage" style="color: #E04F39; font-weight: 500; font-size: 1em; text-align: left; padding: 0 20px;">
                            {{ errorMessage }}
                        </p>
                    </slot>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px;" @click="closeModal()">
                            {{ submitSuccess ? 'Close' : 'Cancel' }}
                        </p>
                        <p v-if="!submitSuccess" class="regular-button complete-button" @click="createAdministration()">
                            {{ loading ? 'Recording...' : 'Create Administration row' }}
                        </p>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'FillAdministrationModal',
    // prefill is the administration_prefill block from the register entry. Everything shown is read from
    // the retrieval - nothing here is editable, because the administration is a record of what the
    // retrieval already says happened.
    props: ['prefill'],
    emits: ['close', 'created'],
    data() {
        return {
            loading: false,
            submitSuccess: false,
            errorMessage: ''
        };
    },
    computed: {
        fields() {
            const prefill = this.prefill || {};
            return [
                { label: this.$resident({ capitalize: true }), value: prefill.patient },
                { label: 'Medication', value: prefill.drug },
                { label: 'Quantity', value: prefill.quantity },
                { label: 'Batch', value: prefill.batch_name },
                { label: 'Administered By', value: prefill.retrieved_by },
                { label: 'Witness', value: prefill.witness },
                { label: 'Prescriber', value: prefill.prescriber },
                { label: 'Date', value: prefill.date },
                { label: 'Notes', value: prefill.notes }
            ];
        }
    },
    methods: {
        closeModal() {
            this.$emit('close', true);
        },
        createAdministration() {
            if (this.loading || !this.prefill || !this.prefill.drug_safe_retrieval) return;

            this.loading = true;
            this.errorMessage = '';

            axios.post('/fill-retrieval-administration', {
                drug_safe_retrieval: this.prefill.drug_safe_retrieval
            }, this.$store.state.header).then(() => {
                this.$store.dispatch('getRefreshToken');
                this.submitSuccess = true;
                this.$emit('created', true);
            }).catch(err => {
                const data = err.response ? err.response.data : null;
                this.errorMessage = (data && typeof data === 'string')
                    ? data
                    : ((data && data.message ? data.message + ' ' : '')
                        + (data && data.errors ? Object.values(data.errors).flat()[0] : ''))
                        || 'The administration could not be recorded. Please try again.';
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.fill-administration-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px 20px;
    padding: 10px 20px 20px 20px;
    text-align: left;
}

.fill-administration-field {
    .field-title {
        margin: 0;
        font-size: 0.8em;
        font-weight: 600;
        text-transform: uppercase;
    }

    .field-value {
        margin: 0;
        font-size: 1em;
        word-break: break-word;
    }
}
</style>
